// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"appointments_wrapper__2oiqa","header":"appointments_header__3UcNQ","title":"appointments_title__e9w65","content":"appointments_content__1PUqd"};